import { render, staticRenderFns } from "./SidebarVariant.vue?vue&type=template&id=64e1f8cb&"
import script from "./SidebarVariant.vue?vue&type=script&lang=js&"
export * from "./SidebarVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports